import BaseProxy from './BaseProxy';

class Auth extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/school', parameters);
    }

    async getAll(params = null) {
        return this.submit('get', '/all', params);
    }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/api/School.js